import React from 'react';
import { Settings } from 'lucide-react';
import { useUserProfile } from '../hooks/useUserProfile';

interface AccountMenuProps {
  onOpenSettings?: () => void;
}

const AccountMenu: React.FC<AccountMenuProps> = ({ onOpenSettings }) => {
  const { user } = useUserProfile();

  // Si pas d'utilisateur, ne pas afficher de bouton
  if (!user) {
    return null;
  }

  return (
    <button
      onClick={onOpenSettings}
      className="w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center hover:bg-white shadow-md hover:shadow-lg transition-all duration-200"
      aria-label="Paramètres"
    >
      <Settings size={20} className="text-gray-700" />
    </button>
  );
};

export default AccountMenu;
